export default "__VITE_ASSET__CGkU9Q7u__"